"use client";

import ExitMenu from "@/app/_components/ExitMenu";
import Home2Icon from "@/app/_components/Icons/Home2Icon";
import LocationIcon from "@/app/_components/Icons/locationIcon";
import LocationMinusIcon from "@/app/_components/Icons/LocationMinusIcon";
import UserEditIcon from "@/app/_components/Icons/UserEditIcon";
import { MenuListItem } from "@/app/admin/types/MenuListItem";
import { ContactPage, ExpandLess, ExpandMore, FolderShared, LocationOn, Badge } from "@mui/icons-material";
import {
  Card,
  ListItem,
  List,
  Collapse,
  Link,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  CardContent,
  Typography,
  Icon,
  Box,
  useScrollTrigger,
} from "@mui/material";
import { useSession } from "next-auth/react";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import ActivityIcon from "@/app/_components/Icons/ActivityIcon";
import EyeIcon from "@/app/_components/Icons/EyeIcon";

// Memoized LinkSingleItem component
const LinkSingleItem = React.memo(function LinkSingleItem({ item, handleClose }: { item: MenuListItem; handleClose?: () => void }) {
  const pathname = usePathname();
  const selected = item.href === pathname;
  return (
    <ListItem
      component={NextLink}
      onClick={() => {
        handleClose && handleClose();
      }}
      href={item.href || "/"}
      sx={{
        position: "relative",
        // backgroundColor: selected ? "secondary.50" : "inherit",
        color: "inherit",
      }}
      disablePadding
    >
      {selected && (
        <Box
          sx={{
            width: 4,
            height: 24,
            backgroundColor: "secondary.main",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            borderTopRightRadius: 500,
            borderBottomRightRadius: 500,
          }}
        ></Box>
      )}
      <ListItemButton
        disableRipple
        sx={{
          justifyContent: "initial",
        }}
      >
        <ListItemIcon
          sx={{
            justifyContent: "center",
            color: selected ? "secondary.main" : "grey.800", // Dynamic color for sub-items
          }}
        >
          {item.icon}
        </ListItemIcon>
        <ListItemText primary={<Typography color={selected ? "secondary" : "grey.600"}>{item.title}</Typography>} />
      </ListItemButton>
    </ListItem>
  );
});

function SideMenu({ handleClose }: { handleClose?: () => void }) {
  const trigger = useScrollTrigger();
  const { data: session } = useSession();
  const items: MenuListItem[] = [
    {
      title: "حساب کاربری",
      href: "/profile",
      icon: (
        <Icon>
          <Home2Icon />
        </Icon>
      ),
    },
    {
      title: "پیگیری سفارشات",
      href: "/profile/orders",
      icon: (
        <Icon>
          <ActivityIcon />
        </Icon>
      ),
    },
    {
      title: "آدرس ها",
      href: "/profile/address",
      icon: (
        <Icon>
          <LocationMinusIcon />
        </Icon>
      ),
    },
    {
      title: "بازدید های اخیر",
      href: "/profile/recent-views",
      icon: (
        <Icon>
          <EyeIcon />
        </Icon>
      ),
    },
    {
      title: "اطلاعات شخصی",
      href: "/profile/edit",
      icon: (
        <Icon>
          <UserEditIcon />
        </Icon>
      ),
    },
  ];

  const fullName =
    session?.user?.me.firstName && session?.user?.me.lastName ? session?.user?.me.firstName + " " + session?.user?.me.lastName : null;
  return (
    <Card
      elevation={0}
      sx={{
        transition: "0.3s all",
        borderRadius: 3,
        boxShadow: { xs: "none", md: "3px 6px 24px -6px #E8D9CF29, -3px 0px 24px -6px #E8D9CF1F" },
        backgroundColor: { xs: "transparent", md: "#fff" },
        position: { xs: "relative", md: "sticky" }, // Sticky only on medium screens and up
        top: { xs: 0, md: trigger ? "88px" : "158px" },
        // borderTop: 2,
        // borderBottom: 2,
        // borderColor: "primary.main",
      }}
    >
      <CardContent>
        <Typography variant="body2" color="grey.600">
          سلام. خوش اومدی{" "}
        </Typography>
        <Typography variant="subtitle1">{fullName || session?.user?.me.phoneNumber} </Typography>
      </CardContent>
      <Divider />
      <List disablePadding>
        {items.map((item, index) => (
          <LinkSingleItem item={item} key={index} handleClose={handleClose} />
        ))}
      </List>
      <Divider />
      <List disablePadding>
        <ExitMenu listItem />
      </List>
    </Card>
  );
}

export default React.memo(SideMenu);
